<template>
  <div>
    <div class="toast-panel" v-text="item.msg" v-for="(item,index) in msgList">
    </div>
  </div>
</template>

<script>

import {isnull} from "../../utils/tools";

export default {
  name: "Custom-Toast",
  props: {
    msgList: {
      type: Array,
      default: new Array()
    },
  },
  data() {
    return {}
  },
  mounted() {
    let target = this
    setTimeout(function () {
      target.drawMsg = false
      target.onMsgShowFinished()
    }, this.time)
  },
  watch: {
    msgList(n, o) {
      for (let i = 0; i < n.length; i++) {
        let tmp = n[i];
        if (!tmp.inShow) {
          tmp.inShow = true;
          let target = this;
          setTimeout(function () {
            target.removeMsg(tmp)
          }, tmp.time)
        }
      }
    }
  },
  methods: {
    onMsgShowFinished() {
      this.$emit('msgShowFinished')
    },
    removeMsg(item) {
      let index = this.findIndexByUid(item)
      if (index != -1)
        this.msgList.splice(index, 1)
    },
    findIndexByUid(item) {
      if (!isnull(item) && !isnull(this.msgList))
        for (let i = 0; i < this.msgList.length; i++) {
          let tmp = this.msgList[i]
          if (tmp.uid == item.uid)
            return i;
        }
      return -1;
    }
  }
}
</script>

<style  scoped lang="less">
@import "~styles/index.less";
@import "~styles/variable.less";

.toast-panel {
  text-align: center;
  .padding(30, 60);
  z-index: 1000;
  .fs(30);
  .maxw(580);
  background: rgba(0, 0, 0, .4);
  font-family: Gilroy-Medium;
  color: rgba(255, 255, 255, 1);
  //margin-left: 50%;
  top: 50%;
  //transform: translate(-50%, -50%);
  position: fixed;
  transform: translate(calc(50vw - 50% ),-50%);

  .b-radius(10);
  word-break: normal;
  white-space: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/widget/Toast.vue